import mapValues from 'lodash/mapValues';
import type { IGenericObject } from 'types';

export const cleanObject = (obj: IGenericObject): IGenericObject => {
  for (const propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
      delete obj[propName];
    }
  }
  return obj;
};

export const setObjectValues = (obj: IGenericObject, value: any): IGenericObject =>
  mapValues(obj, (o) => (typeof o === 'object' ? setObjectValues(o, value) : value));
